/**
 * Normalizes Grails account API payloads to the inner account record.
 * Handles both { data: { showChatbot, ... } } and flat { showChatbot, ... }.
 */
export function normalizeAccountRecord(payload) {
  if (!payload || typeof payload !== "object") {
    return {};
  }

  const nested = payload.data;
  if (
    nested != null &&
    typeof nested === "object" &&
    !Array.isArray(nested) &&
    (payload.showChatbot === undefined ||
      payload.chatbotBetaEnrolled === undefined) &&
    (nested.showChatbot !== undefined ||
      nested.chatbotBetaEnrolled !== undefined ||
      nested.shop_name !== undefined)
  ) {
    return nested;
  }

  return payload;
}
